(function(){
  function $all(r,s){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  /* announcement rotator: un messaggio alla volta, fermo se l'utente riduce il movimento */
  $all(document,'[data-bl-ann]').forEach(function(root){
    var items=$all(root,'.bl-ann__item'); if(items.length<2)return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    root.classList.add('is-js'); var i=0; items[0].classList.add('is-on');
    setInterval(function(){items[i].classList.remove('is-on');i=(i+1)%items.length;items[i].classList.add('is-on');},4500);
  });
  /* gallery prodotto: frecce, contatore, miniature */
  $all(document,'[data-bl-gal]').forEach(function(root){
    var track=root.querySelector('.bl-gal__track'),slides=$all(root,'.bl-gal__slide'),count=root.querySelector('.bl-gal__count'),thumbs=$all(root,'.bl-gal__thumb');
    function idx(){return Math.round(track.scrollLeft/track.clientWidth);}
    function go(n){n=Math.max(0,Math.min(slides.length-1,n));track.scrollTo({left:n*track.clientWidth,behavior:'smooth'});}
    function sync(){var n=idx();if(count)count.textContent=(n+1)+' / '+slides.length;thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===n);});}
    var p=root.querySelector('.bl-gal__btn--prev'),nx=root.querySelector('.bl-gal__btn--next');
    if(p)p.addEventListener('click',function(){go(idx()-1);});
    if(nx)nx.addEventListener('click',function(){go(idx()+1);});
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k);});});
    track.addEventListener('scroll',function(){window.requestAnimationFrame(sync);},{passive:true}); sync();
  });
  /* slider generico video/immagini */
  $all(document,'[data-bl-ms]').forEach(function(root){
    var track=root.querySelector('.bl-ms__track'); if(!track)return;
    function step(d){var it=track.querySelector('.bl-ms__item');var w=it?it.getBoundingClientRect().width+12:300;track.scrollBy({left:d*w,behavior:'smooth'});}
    var p=root.querySelector('[data-bl-prev]'),n=root.querySelector('[data-bl-next]');
    if(p)p.addEventListener('click',function(){step(-1);}); if(n)n.addEventListener('click',function(){step(1);});
    var vids=$all(root,'video');
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});}else{v.pause();}});},{threshold:.5});vids.forEach(function(v){io.observe(v);});}
  });
})();
